import { render } from "./BrandStyriaMarketingServices.vue?vue&type=template&id=42b396b1"
import script from "./BrandStyriaMarketingServices.vue?vue&type=script&lang=ts"
export * from "./BrandStyriaMarketingServices.vue?vue&type=script&lang=ts"

import "./BrandStyriaMarketingServices.vue?vue&type=style&index=0&id=42b396b1&lang=scss"
script.render = render

export default script